import React, { useEffect, useState } from "react";
import { Table, Tooltip } from "antd";
import { secondsToDhms } from "../../../redux/constants/index";

const TableOrm = ({
  single,
  widget_id,
  graphType,
  flr,
  resolution,
  tabData,
}) => {
  const dataSource = single?.dataSource;

  const [dataSource1, setDataSource1] = useState([]);
  const [gridPieDataA, setGridPieDataA] = useState([]);
  const [gridPieDataB, setGridPieDataB] = useState([]);
  const [agentData, setAgentData] = useState([]);

  useEffect(() => {
    if (widget_id == "tickets_orm_12") {
      let avg = [];
      dataSource?.map((d) => {
        avg.push({
          channelName: d["Channel Name"],
          totalTickets: d["Total Tickets"],
          closedTickets: d["Closed Tickets"],
          averageFirstResponseTime: (
            <span class={d["Average First Response Time"] > flr ? "error" : ""}>
              {secondsToDhms(d["Average First Response Time"])
                ? secondsToDhms(d["Average First Response Time"])
                : 0}
            </span>
          ),
          averageResolutionTime: (
            <span
              class={d["Average Resolution Time"] > resolution ? "error" : ""}
            >
              {secondsToDhms(d["Average Resolution Time"])
                ? secondsToDhms(d["Average Resolution Time"])
                : 0}
            </span>
          ),
        });
      });
      setDataSource1(avg);
    }

    if (widget_id == "tickets_orm_24a" && tabData == 1) {
      let avg = [];
      dataSource?.map((d) => {
        avg.push({
          upperCategory: d["Upper Category"],
          total: d["Total"],
          unactioned: d["Unactioned"],
          workInProgress: d["Work in Progress"],
          closed: d["Closed"],
          avgFlr: d["Avg. FLR"],
          avgTat: d["Avg. TAT"],
        });
      });
      setGridPieDataA(avg);
    }

    if (widget_id == "tickets_orm_24b" && tabData == 2) {
      let avg = [];
      dataSource?.map((d) => {
        avg.push({
          upperCategory: d["Upper Category"],
          total: d["Total"],
          unactioned: d["Unactioned"],
          workInProgress: d["Work in Progress"],
          closed: d["Closed"],
          avgFlr: d["Avg. FLR"],
          avgTat: d["Avg. TAT"],
        });
      });
      setGridPieDataB(avg);
    }

    if (widget_id == "tickets_orm_18") {
      let avg = [];
      dataSource?.map((d, i) => {
        avg.push({
          AgentSupervisorName: d["Agent/Supervisor Name"],
          TotalCount: d["Total Count"],
          Unactioned: d["Unactioned"],
          DirectlyClosed: d["Directly Closed"],
          ReplyAndClosed: d["Reply & Closed"],
          EscalatedAndClosed: d["Escalate & Closed"],
          EscalatedPendingWithCSD: d["Escalated (Pending with CSD)"],
          EscalatedPendingWithBrand: d["Escalated (Pending with Brand)"],
          CSDRevertedPendingwithAgent: d["CSD Reverted (Pending with Agent)"],
          KeptOnhold: d["Kept on Hold"],
          AwaitingInfoFromCustomer: d["Awaiting Info From Customer"],
          AcknowledgeByAgent: d["Acknowledge By Agent"],
          ReplyAndAcknowledgeByAgent: d["Reply And Acknowledge By Agent"],
          WorkingHourTAT: (
            <span>
              {secondsToDhms(d["Working Hour TAT"])
                ? secondsToDhms(d["Working Hour TAT"])
                : 0}
            </span>
          ),
          TotalTAT: (
            <span>
              {secondsToDhms(d["Total TAT"])
                ? secondsToDhms(d["Total TAT"])
                : 0}
            </span>
          ),
        });
      });
      setAgentData(avg);
    }
  }, [widget_id, tabData, flr, resolution]);

  const gridPieColumns = [
    {
      title: "Upper Category",
      dataIndex: "upperCategory",
      key: "upperCategory",
      sorter: (a, b) => a.upperCategory.length - b.upperCategory.length,
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "totalTickets",
      sorter: (a, b) => a.total - b.total,
    },
    {
      title: "Unactioned",
      dataIndex: "unactioned",
      key: "unactioned",
      sorter: (a, b) => a.unactioned - b.unactioned,
    },
    {
      title: "Work in Progress",
      dataIndex: "workInProgress",
      key: "workInProgress",
      sorter: (a, b) => a.workInProgress - b.workInProgress,
    },
    {
      title: "Closed",
      dataIndex: "closed",
      key: "closed",
      sorter: (a, b) => a.closed - b.closed,
    },
    {
      title: "AVG. FLR",
      dataIndex: "avgFlr",
      key: "avgFlr",
      sorter: (a, b) => a.avgFlr.length - b.avgFlr.length,
    },
    {
      title: "AVG. TAT",
      dataIndex: "avgTat",
      key: "avgTat",
      sorter: (a, b) => a.avgTat.length - b.avgTat.length,
    },
  ];

  const columns1 = [
    {
      title: "Channel Name",
      dataIndex: "channelName",
      key: "channelName",
    },
    {
      title: "Total Tickets",
      dataIndex: "totalTickets",
      key: "totalTickets",
    },
    {
      title: "Closed Tickets",
      dataIndex: "closedTickets",
      key: "closedTickets",
    },
    {
      title: "Average First Response Time",
      dataIndex: "averageFirstResponseTime",
      key: "averageFirstResponseTime",
    },
    {
      title: "Average Resolution Time",
      dataIndex: "averageResolutionTime",
      key: "averageResolutionTime",
    },
  ];

  const columnsData = single?.columns?.map((Item, i) => {
    return Item?.title;
  });

  let columnsObj = [];
  let columnsObjch = [];
  let columnsObjnew = [
    {
      title: "Actioned",
      children: columnsObjch,
    },
  ];

  const columnsGrid = [
    {
      title: "Duration",
      dataIndex: "Duration",
      key: "1",
    },
    {
      title: "Total Tickets",
      dataIndex: "Total Tickets",
      key: "2",
    },
    {
      title: "Directly Closed",
      dataIndex: "Directly Closed",
      key: "3",
    },
    {
      title: "Reply & Closed",
      children: [
        {
          title: "With Escalation",
          dataIndex: "With Escalation",
          key: "4",
        },
        {
          title: (
            <span>
              Without Escalation (FTR)
              <Tooltip title="First time resolution" placement="bottom">
                <i
                  className="fa fa-question-circle ml-1"
                  style={{ color: "#007bff" }}
                />
              </Tooltip>
            </span>
          ),
          dataIndex: "Without Escalation (FTR)",
          key: "5",
        },
      ],
    },
    {
      title: "Awaiting From Customer",
      dataIndex: "Awaiting From Customer",
      key: "6",
    },
    {
      title: "Pending With Agent",
      children: [
        {
          title: "Unactioned",
          children: [
            {
              title: "Open",
              dataIndex: "Open",
              key: "7",
            },
            {
              title: "On hold",
              dataIndex: "On Hold",
              key: "8",
            },
          ],
        },
        {
          title: "Post Revert From CSD/User",
          dataIndex: "Post Revert From CSD/User",
          key: "9",
        },
      ],
    },
    {
      title: "Pending With Brand/CSD",
      dataIndex: "Pending With Brand/CSD",
      key: "10",
    },
  ];

  const AgentTicketStatus = [
    {
      title: "",
      children: [
        {
          title: "Agent/Supervisor Name",
          dataIndex: "AgentSupervisorName",
          key: "1",
        },
        {
          title: "Total Count",
          dataIndex: "TotalCount",
          key: "2",
        },
        {
          title: "Unactioned",
          dataIndex: "Unactioned",
          key: "3",
        },
      ],
    },
    {
      title: "Actioned",
      children: [
        {
          title: "Directly Closed",
          dataIndex: "DirectlyClosed",
          key: "4",
        },
        {
          title: "Reply and Closed",
          dataIndex: "ReplyAndClosed",
          key: "5",
        },
        {
          title: "Escalated and Closed",
          dataIndex: "EscalatedAndClosed",
          key: "6",
        },
        {
          title: "Escalated (Pending with CSD)",
          dataIndex: "EscalatedPendingWithCSD",
          key: "7",
        },
        {
          title: "Escalated (Pending with Brand)",
          dataIndex: "EscalatedPendingWithBrand",
          key: "8",
        },
        {
          title: "CSD Reverted (Pending with Agent)",
          dataIndex: "CSDRevertedPendingwithAgent",
          key: "9",
        },
        {
          title: "Kept Onhold",
          dataIndex: "KeptOnhold",
          key: "10",
        },
        {
          title: "Awaiting Info From Customer",
          dataIndex: "AwaitingInfoFromCustomer",
          key: "11",
        },
        {
          title: "Acknowledge By Agent",
          dataIndex: "AcknowledgeByAgent",
          key: "12",
        },
        {
          title: "Reply And Acknowledge By Agent",
          dataIndex: "ReplyAndAcknowledgeByAgent",
          key: "13",
        },
        {
          title: "Working Hour TAT",
          dataIndex: "WorkingHourTAT",
          key: "14",
        },
        {
          title: "Total TAT",
          dataIndex: "TotalTAT",
          key: "15",
        },
      ],
    },
  ];

  if (widget_id === "tickets_orm_18") {
    for (let i = 0; i < columnsData?.length; i++) {
      columnsObjch?.push({
        title: columnsData[i],
        dataIndex: columnsData[i],
        key: i,
      });
    }
  } else {
    for (let i = 0; i < columnsData?.length; i++) {
      columnsObj?.push({
        title: columnsData[i],
        dataIndex: columnsData[i],
        key: i,
      });
    }
  }

  const columns =
    widget_id === "tickets_orm_18"
      ? columnsObjnew
      : widget_id === "tickets_orm_16"
      ? columnsGrid
      : columnsObj;

  return (
    <div className="p-15">
      <Table
        dataSource={
          widget_id == "tickets_orm_12"
            ? dataSource1
            : widget_id == "tickets_orm_18"
            ? agentData
            : widget_id == "tickets_orm_24a" && tabData == 1
            ? gridPieDataA
            : widget_id == "tickets_orm_24b" && tabData == 2
            ? gridPieDataB
            : dataSource
        }
        pagination={{ 
          defaultPageSize: 10, 
          showSizeChanger: false, 
          hideOnSinglePage: dataSource?.length > 10 ? false : true,
        }}
        columns={
          widget_id == "tickets_orm_12"
            ? columns1
            : widget_id == "tickets_orm_18"
            ? AgentTicketStatus
            : widget_id == "tickets_orm_24a" && tabData == 1
            ? gridPieColumns
            : widget_id == "tickets_orm_24b" && tabData == 2
            ? gridPieColumns
            : columns
        }
        //bordered
        scroll={{
          x: 1000,
        }}
      />
    </div>
  );
};

export default TableOrm;
